"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EventDispatcher = _interopRequireDefault(require("../../../event/EventDispatcher"));
var _DOM = _interopRequireDefault(require("../../../display/DOM"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class KeyObserver extends _EventDispatcher.default {
  constructor() {
    super();
    this.keyHandler = e => {
      this.listenForKeys(e);
    };
  }
  start() {
    (0, _DOM.default)(document).on('keyup keypress', this.keyHandler);
  }
  stop() {
    (0, _DOM.default)(document).off('keyup keypress', this.keyHandler);
  }
  listenForKeys(e) {
    const event = e.type;
    const key = (e.key || '').toLowerCase();
    this.trigger(event, {
      event,
      key
    });
    if (event === 'keyup') {
      if (key === 'escape' || key === 'esc' || e.keyCode === 27) {
        this.trigger('escape');
      } else if (key === 'enter') {
        this.trigger('enter');
      }
    }
  }
}
var _default = exports.default = KeyObserver;
module.exports = exports.default;